angular.module('impactx.demand').controller('DemandDetailCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$mdToast',
    'selectedListItems',
    'basketTemplateMenu',
    '$mdDialog',
    '$redirect',
    'ToolbarService',
    'ToastService',
    'TranslationService',
    'ApprovalOverviewService',
    'TemplateNameService',
    'ConfirmationService',
    'SubsequentPurchaseOrderDataService',
    DemandDetailController
]);

function DemandDetailController($scope, dataGen, $routeParams, $mdToast, selectedListItems, basketTemplateMenu, $mdDialog,
                                $redirect, ToolbarService, ToastService, TranslationService, ApprovalOverviewService,
                                TemplateNameService, ConfirmationService, SubsequentPurchaseOrderDataService) {
    var self = this;
    var dehId = 0;
    if ($routeParams.id) {
        dehId = $routeParams.id;
    }
    else {
        dehId = selectedListItems.getFirstSelectedId();
    }
    $scope.selectedPurchaseItems = [];

    $scope.getPageData = function () {
        dataGen.getData($scope, {id: dehId}, "/demand/view", function () {
            $scope.data.object.comments.internalComments.newComments = [];
            defineButtons();
        });
    };

    $scope.getPageData();

    $scope.showItemComments = {value: false};
    this.toggleItemComment = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };
    $scope.showHeaderComment = {value: false};
    this.toggleComment = function () {
        $scope.showHeaderComment.value = !$scope.showHeaderComment.value;
    };
    $scope.showComments = {value: false};
    $scope.selectedSupplier = [];

    this.toggleSupplierComment = function () {
        $scope.showComments.value = !$scope.showComments.value;
    };

    this.selectSupplier = function (event, supplier) {
        if (event.target.tagName != "MD-SELECT" &&
            (!event.target.parentNode.tagName || event.target.parentNode.tagName != "MD-SELECT-VALUE")
            && (!event.target.parentNode.tagName || !event.target.parentNode.parentNode.tagName || event.target.parentNode.parentNode.tagName != "MD-SELECT-VALUE")) {
            $scope.showComments.value = false;
            for (var i = 0; i < $scope.selectedPurchaseItems.length; i++) {
                $scope.selectedPurchaseItems[i].selected = false;
            }
            $scope.selectedPurchaseItems.splice(0, 1);

            if ($scope.selectedSupplier[0] !== supplier) {
                $scope.selectedSupplier[0] = supplier;
            }
            else {
                $scope.selectedSupplier.splice(0, 1);
            }
        }
    };
    this.createBasketTemplate = function() {
        return TemplateNameService.showTemplateName(selectedListItems.getSelectedItems(), '/basket/template/beforecreatefromdemand', event).then(function(answer){
            if(answer)
            {
                dataGen.postAsForm({}, {items: [{id: dehId}], name: answer}, '/basket/template/createfromdemand').then(function()
                {
                    basketTemplateMenu.refreshAllTemplates();
                    ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                });
            }
        });
    }

    this.cancelItems = function () {
        var newScope = {};
        var selected = [];
        var ids = [];
        for (var i = 0; i < $scope.selectedPurchaseItems.length; i++) {
            if (ids.indexOf($scope.selectedPurchaseItems[i].id) < 0) {
                ids.push($scope.selectedPurchaseItems[i].id);
                if ($scope.selectedPurchaseItems[i].basketItemGroupId > 0) {
                    self.addItemsOfSameBasketItemGroup(ids, $scope.selectedPurchaseItems[i])
                }
            }
        }
        for (var j = 0; j < ids.length; j++) {
            selected.push({deiId: ids[j]});
        }
        return dataGen.getData(newScope, {selected: [selected]}, '/demand/cancellation/view').then(function (data) {
            if (data.errors.length < 1) {
                $redirect.redirectTo(null, "/canceldemand", selected);
            }
        });
    };

    this.addItemsOfSameBasketItemGroup = function (ids, itemToAdd) {
        angular.forEach($scope.data.object.supplierHeaderList, function (supplierHeader) {
            angular.forEach(supplierHeader.requestItems, function (item) {
                if (item.basketItemGroupId === itemToAdd.basketItemGroupId) {
                    if (ids.indexOf(item.id) < 0) {
                        ids.push(item.id);
                    }
                }
            });
        });
    };

    this.cancelAll = function (event) {
        var selected = [];

        angular.forEach($scope.data.object.supplierHeaderList, function (supplierHeader) {
            angular.forEach(supplierHeader.requestItems, function (item) {
                selected.push({deiId: item.id});
            });
        });

        $mdDialog.show({
            controller: "CancelAllDemandCtrl",
            controllerAs: "cancelAllCtrl",
            templateUrl: "modules/cancellation/templates/cancellation-all.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                selectedEntries: selected
            }
        })
    };

    this.redirectToApprovalModified = function (id) {
        $redirect.redirectTo(null, '/approvalmodifieddei/' + id);
    };

    self.formatAddressValue = function (value) {
        if (value) {
            return value.replace(/,\s/g, '<br/>')
        }
        return '';
    }

    self.redirectApproval = function (event, entry) {
        var selectionData = {
            atiId: entry.atiId
        };
        $mdDialog.show({
            controller: 'RedirectUserCtrl',
            templateUrl: 'modules/approval/templates/redirectuser.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            fullscreen: true,
            bindToController: true,
            locals: {
                selectionData: selectionData
            }
        }).then(function (answer) {
            if (answer && answer.id) {
                var dataObj = {
                    atiId: entry.atiId,
                    usrId: answer.id
                }
                dataGen.postAsForm({}, dataObj, '/approval/redirect').then(function (data) {
                    if (data && data.trns) {
                        ToastService.openStandardToast(data.trns.successMessage)
                        $redirect.reload()
                    }
                });
            }
        });
    };

    self.resetApproval = function (event) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {type: "DEH", headerId: $scope.data.object.id}, '/approval/reset').then(function () {
                $redirect.reload();
            })
        }, event, TranslationService.get('warning'), TranslationService.get('ok'), TranslationService.get('abort'), $scope.trns.resetApprovalQuestion);
    };

    self.canOnlyEditSPO = function (supplier) {
        //should normally be false, but just to make sure..
        return self.canEditSPO(supplier) && !supplier.canShowSubsequentPurchaseOrderData;
    };

    self.canEditSPO = function (supplier) {
        return supplier && supplier.canEditSPO;
    };

    self.editSPO = function (event, supplier) {
        SubsequentPurchaseOrderDataService.openEditDialog(event, supplier.id, "des");
    }

    self.openSubsequentPurchaseOrderDataDialog = function (event, supplier) {
        if (self.canEditSPO(supplier)) {
            self.editSPO(event, supplier);
        } else {
            SubsequentPurchaseOrderDataService.openViewDialog(event, 0, supplier.id, 0);
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.comments,
                action: self.toggleComment,
                type: 'dialogaction',
                condition: hasNoItemsSelected
            },
            {
                label: $scope.trns.comments,
                action: self.toggleItemComment,
                type: 'dialogaction',
                condition: hasItemsSelected
            },
            {
                label: $scope.trns.comments,
                action: self.toggleSupplierComment,
                type: 'dialogaction',
                condition: hasSupplierSelected
            },
            {
                label: $scope.trns.openSentBackBasket,
                linkFunction: getSendBackBasketLink,
                type: 'link',
                condition: canSendBasketBack
            },
            {
                label: $scope.trns.cancel,
                action: self.cancelItems,
                type: 'dialogaction',
                condition: canCancelItems
            },
            {
                label: $scope.trns.cancelAll,
                action: self.cancelAll,
                type: 'dialogaction',
                condition: canCancel
            },
            {
                label: $scope.trns.createTemplate,
                action: self.createBasketTemplate,
                type: 'dialogaction',
                condition: canCreateTemplate
            },
            {
                label: $scope.trns.approvalmodified,
                action: self.redirectToApprovalModified,
                type: 'dialogaction',
                condition: canRedirectToApproval
            },
            {
                label: $scope.trns.approvalDetails,
                action: openApprovalOverviewDialog,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.resetApproval,
                action: self.resetApproval,
                type: 'dialogaction',
                condition: canResetApproval
            },
            {
                label: $scope.trns.print,
                type: 'print',
                params: {
                    printToken: $scope.printTokens.demand
                }
            },
            {
                label: $scope.trns.editSPO,
                action: self.editSPO,
                type: 'dialogaction',
                condition: self.canOnlyEditSPO
            },
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function hasNoItemsSelected() {
        return !$scope.selectedPurchaseItems.length && !$scope.selectedSupplier.length;
    }

    function hasItemsSelected() {
        return $scope.selectedPurchaseItems.length > 0;
    }

    function hasSupplierSelected() {
        return $scope.selectedSupplier.length > 0;
    }

    function getSendBackBasketLink() {
        return "basket/" + $scope.data.object.basketId;
    }

    function canSendBasketBack() {
        return $scope.data.object.canOpenStoppedBasket;
    }

    function canCancelItems() {
        return hasItemsSelected() && canCancel();
    }

    function canCancel() {
        return $scope.data.object.canCancel;
    }

    function canCreateTemplate() {
        return $scope.data.object.canCreateTemplate;
    }

    function canRedirectToApproval() {
        return $scope.selectedPurchaseItems.length == 1 && $scope.selectedPurchaseItems[0].showApprovalModifiedLink;
    }

    function canResetApproval() {
        return $scope.data.object.canResetApproval;
    }

    function openApprovalOverviewDialog(event) {
        ApprovalOverviewService.openDialog(event, 0, dehId);
    }
}
